import { useQuery } from '@tanstack/react-query';
import { listDriveFolders } from '@/services/triggers/triggers';
import { DriveFolderPage } from '@/services/triggers/types';

export const driveFoldersQueryKey = (
  orgId?: string,
  connectionId?: string,
  search?: string,
) => ['drive-folders', orgId, connectionId, search ?? ''];

export const useListDriveFolders = (
  orgId?: string,
  connectionId?: string,
  search?: string,
  enabled = true,
) =>
  useQuery<DriveFolderPage>({
    queryKey: driveFoldersQueryKey(orgId, connectionId, search),
    queryFn: () => listDriveFolders(orgId!, connectionId!, { q: search }),
    enabled: !!orgId && !!connectionId && enabled,
    // Folder lists are a live Drive read through Composio; keep them briefly so
    // typing in the picker doesn't refetch on every keystroke remount.
    staleTime: 30_000,
  });
